import React, { useState } from 'react';
import './Inventario.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { FaChevronDown, FaChevronRight, FaBars } from 'react-icons/fa';
import CatalogoProveedores from './catalogos/CatalogoProveedores';
import CatalogoInsumos from './catalogos/CatalogoInsumos';
import CatalogoUnidades from './catalogos/CatalogoUnidades';
import CatalogoCategorias from './catalogos/CatalogoCategorias';
import NuevaCompraModal from '../Compras/modals/NuevaCompraModal';
import CatalogoDestinos from './catalogos/CatalogoDestinos';

const Inventario = () => {
  const [menuAbierto, setMenuAbierto] = useState(true);
  const [vistaActual, setVistaActual] = useState('catalogos-insumos');
  const [itemsColapsados, setItemsColapsados] = useState({
    catalogos: false,
    compras: true,
    recetas: true,
    destinos: true
  });

  // Manejar navegación del menú
  const toggleMenuItem = (item) => {
    setItemsColapsados({
      ...itemsColapsados,
      [item]: !itemsColapsados[item]
    });
  };

  const cambiarVista = (vista) => {
    setVistaActual(vista);
  };

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  // Renderizar contenido según vista actual
  const renderContenido = () => {
    switch (vistaActual) {
      case 'catalogos-proveedores':
        return <CatalogoProveedores />;
      case 'catalogos-insumos':
        return <CatalogoInsumos />;
      case 'catalogos-categorias':
        return <CatalogoCategorias />;
      case 'catalogos-unidades':
        return <CatalogoUnidades />;
      case 'compras':
        return <NuevaCompraModal isOpen={true} embedded={true} />;
      case 'destinos-configurar':
        return <CatalogoDestinos />;
      default:
        return <CatalogoInsumos />;
    }
  };

  return (
    <div className="inventario-wrapper">
      <Header
        titulo='Inventario'
        color='#667eea'
      />

      <div className="inventario-container">
        {/* Menú lateral */}
        <div className={`menu-lateral ${menuAbierto ? 'abierto' : 'cerrado'}`}>
          <div className="menu-header">
            <button className="toggle-menu" onClick={toggleMenu}>
              <FaBars />
            </button>
            <span className="menu-titulo">Módulos</span>
          </div>

          <div className="menu-items">
            {/* Catálogos */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('catalogos')}>
                {itemsColapsados.catalogos ? <FaChevronRight /> : <FaChevronDown />}
                <span>Catálogos</span>
              </div>
              {!itemsColapsados.catalogos && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'catalogos-proveedores' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('catalogos-proveedores')}
                  >
                    Proveedores
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'catalogos-insumos' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('catalogos-insumos')}
                  >
                    Insumos
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'catalogos-categorias' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('catalogos-categorias')}
                  >
                    Categorías
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'catalogos-unidades' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('catalogos-unidades')}
                  >
                    Unidades
                  </div>
                </div>
              )}
            </div>

            {/* Compras */}
            <div className="menu-item">
              <div
                className={`menu-item-header inventario-directo ${vistaActual === 'compras' ? 'activo' : ''}`}
                onClick={() => cambiarVista('compras')}
              >
                <span>Compras</span>
              </div>
            </div>

            {/* Destinos Salidas/Entradas */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('destinos')}>
                {itemsColapsados.destinos ? <FaChevronRight /> : <FaChevronDown />}
                <span>Destinos Salidas/Entradas</span>
              </div>
              {!itemsColapsados.destinos && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'destinos-configurar' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('destinos-configurar')}
                  >
                    Configurar Destinos
                  </div>

                </div>
              )}
            </div>

            {/* Salir */}
            <div className="menu-item">
              <div className="menu-item-header salir">
                <span>Salir</span>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className={`inventario-content ${menuAbierto ? 'con-menu' : 'sin-menu'}`}>
          <div className="inventario-inner">
            <div className="inventario-header">
              <h1 className="inventario-titulo">
                {vistaActual === 'catalogos-proveedores' ? 'Catálogo de Proveedores' :
                  vistaActual === 'catalogos-insumos' ? 'Catálogo de Insumos' :
                    vistaActual === 'catalogos-categorias' ? 'Catálogo de Categorías' :
                      vistaActual === 'catalogos-unidades' ? 'Catálogo de Unidades' :
                        vistaActual === 'compras' ? 'Compras' :
                          vistaActual === 'destinos-configurar' ? 'Configurar Destinos' :
                            'Catálogo de Insumos'}
              </h1>
            </div>

            {renderContenido()}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Inventario;
